var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.refundTotal > 0)?_c('div',_vm._l((_vm.refunds),function(refund){return _c('p',{key:refund.id},[_vm._v("\n    "+_vm._s(_vm.$t('paymentTerms.refund',
          { amount: refund.amount_decorated, date: _vm.dateConvert(refund.created_at) }))+"\n  ")])}),0):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }